// extracted by mini-css-extract-plugin
module.exports = {"titleText":"az_s7c","newFulfillmentTitle":"az_t7c"};